import React, { memo } from 'react';
import * as ST from './styled';
import DeviceGridItem from '~/src/components/Equipment/internet/DeviceGridItem';

const DevicesGrid = ({ devices, orderText, selectable, createOrder, baseRoute, dataTest }) => (
    <ST.GridContainer data-test={dataTest}>
        {
            devices.map(item => (
                <DeviceGridItem
                    key={item.id}
                    item={item}
                    baseRoute={baseRoute}
                    createOrder={createOrder}
                    orderText={orderText}
                    selectable={selectable}
                />
            ))
        }
    </ST.GridContainer>
);

export default memo(DevicesGrid);
